<svelte:options customElement="hb-layout-mobile" />

<script lang="ts">
  /**
   * Svelte Video Gallery WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import pkg from "../../../package.json";

  import type { Events as OffcanvasEvents } from "../offcanvas/types/webcomponent.type";
  import type { Events as SidebarDesktopEvents } from "../sidebar-desktop/types/webcomponent.type";
  import type { Events as NavbarEvents } from "../navbar/types/webcomponent.type";
  import type { Events as FooterEvents } from "../footer/types/webcomponent.type";

  import type { Component } from "./types/webcomponent.type";
  import { addComponent, LanguageTranslator } from "wc-js-utils";

  let {
    id = "",
    // style = "",
    footer = { type: "auto", disable_expanding_small: false },
    cookielawuri4more = "",
    cookielawallowdecline = undefined,
    cookielawlanguage = "",
    pagename = undefined,
    cookielaw = undefined,
    single_screen = undefined,
    sidebar = {},
    socials = undefined,
    navlinks = undefined,
    contacts = undefined,
    columns = undefined,
    usermenu = undefined,
    i18nlang = undefined,
    i18nlanguages = undefined,
    page_title = undefined,
    policies = undefined,
    company = undefined,
  }: Component = $props();

  // let translator: LanguageTranslator;
  let navopen: boolean = $state(false);

  $effect(() => {
    if (typeof footer === "string") footer = JSON.parse(footer);
    if (!footer.type) footer.type = "auto";

    if (typeof single_screen === "string") {
      if (single_screen !== "no") single_screen = true;
      else single_screen = false;
    } else if (!single_screen) {
      single_screen = false;
    }

    if (typeof sidebar === "string") {
      sidebar = JSON.parse(sidebar);
    }
    if (typeof company === "string") {
      company = JSON.parse(company as unknown as string);
    }

    // 		if (!translator) {
    // 	translator = new LanguageTranslator({ dictionary, lang: i18nlang });
    // } else if (translator && i18nlang && translator.lang && translator.lang !== i18nlang) {
    // 	translator = new LanguageTranslator({ dictionary, lang: i18nlang });
    // }
  });

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  addComponent({ repoName: "@htmlbricks/hb-footer", version: pkg.version });
  addComponent({ repoName: "@htmlbricks/hb-offcanvas", version: pkg.version });
  addComponent({ repoName: "@htmlbricks/hb-navbar", version: pkg.version });
  addComponent({
    repoName: "@htmlbricks/hb-cookie-law-banner",
    version: pkg.version,
  });
  addComponent({
    repoName: "@htmlbricks/hb-sidebar-desktop",
    version: pkg.version,
  });

  function openmenu(o: OffcanvasEvents["offcanvasswitch"]) {
    console.log("burgerclick", o);
    navopen = o.isOpen;

    dispatch("offcanvasswitch", o);
  }
</script>

{#if navlinks?.length}
  <hb-offcanvas
    navpage={pagename || ""}
    navlinks={navlinks || "[]"}
    companytitle={sidebar?.title}
    companylogouri={sidebar?.logo}
    i18nlang={i18nlang || ""}
    {i18nlanguages}
    enablethemeswitch={sidebar?.enablethemeswitch || "yes"}
    onoffcanvasswitch={(el: { detail: OffcanvasEvents["offcanvasswitch"] }) =>
      openmenu(el.detail)}
    opened={navopen ? "yes" : "no"}
    type="autohide"
    onpageChange={(p: { detail: OffcanvasEvents["pageChange"] }) =>
      dispatch("pageChange", p.detail)}
    onlanguageChange={(e: { detail: SidebarDesktopEvents["languageChange"] }) =>
      dispatch("languageChange", e.detail)}
    onthemeChange={(e: { detail: SidebarDesktopEvents["themeChange"] }) =>
      dispatch("themeChange", e.detail)}
  >
    <span slot="header"><slot name="nav-header-slot" /></span>
  </hb-offcanvas>
{/if}
<div
  class="hb-layout-mobile__shell"
  class:hb-layout-mobile__shell--single-screen={single_screen}
  part="container"
>
  <hb-navbar
    part="navbar"
    noburger={navlinks ? "" : "yes"}
    companylogouri={company?.logoUri || ""}
    companybrandname={page_title || company?.siteName || ""}
    usermenu={usermenu || ""}
    switchopen={navopen ? "yes" : "no"}
    onnavmenuswitch={(el: { detail: NavbarEvents["navmenuswitch"] }) =>
      openmenu(el.detail)}
    onnavbarDropDownClick={(el: {
      detail: NavbarEvents["navbarDropDownClick"];
    }) => dispatch("navbarDropDownClick", el.detail)}
    onnavbarSlotClick={(l: { detail: NavbarEvents["navbarSlotClick"] }) =>
      dispatch("navbarSlotClick", l.detail)}
  >
    <span slot="left-slot"><slot name="nav-left-slot" /></span>
    <span slot="center-slot"><slot name="nav-center-slot" /></span>
    <span slot="right-slot"><slot name="nav-right-slot" /></span>
  </hb-navbar>

  {#if single_screen}
    <div class="hb-layout-mobile__page" part="page" id="page">
      <slot name="page">page</slot>
    </div>
    {#if cookielaw === "yes" || cookielaw === "true" || cookielawallowdecline === "yes" || cookielawallowdecline === "no" || cookielawlanguage?.length || cookielawuri4more?.length}
      <hb-cookie-law-banner
        language={cookielawlanguage || i18nlang}
        allowdecline={cookielawallowdecline}
        {cookielawuri4more}
      ></hb-cookie-law-banner>
    {/if}
    <hb-footer
      {policies}
      type={footer.type === "auto" ? "small" : footer.type}
      part="footer"
      socials={socials ? JSON.stringify(socials) : ""}
      contacts={contacts ? JSON.stringify(contacts) : ""}
      style="display:block;"
      company={company ? JSON.stringify(company) : ""}
      columns={columns || ""}
      disable_expanding_small={footer.disable_expanding_small ? "yes" : "no"}
      onfooterClick={(el: { detail: FooterEvents["footerClick"] }) =>
        dispatch("footerClick", el.detail)}
    ></hb-footer>
  {:else}
    <div
      class="hb-layout-mobile__page hb-layout-mobile__page--footer-inside"
      part="page"
      id="page"
    >
      <div class="hb-layout-mobile__page-stretch">
        <div class="hb-layout-mobile__page-slot">
          <slot name="page">page</slot>
        </div>
        {#if cookielaw === "yes" || cookielaw === "true" || cookielawallowdecline === "yes" || cookielawallowdecline === "no" || cookielawlanguage?.length || cookielawuri4more?.length}
          <hb-cookie-law-banner
            language={cookielawlanguage || i18nlang}
            allowdecline={cookielawallowdecline}
            {cookielawuri4more}
          ></hb-cookie-law-banner>
        {/if}
        <hb-footer
          {policies}
          type={footer.type === "auto" ? "regular" : footer.type}
          part="footer"
          socials={socials ? JSON.stringify(socials) : ""}
          contacts={contacts ? JSON.stringify(contacts) : ""}
          style="display:block;"
          company={company ? JSON.stringify(company) : ""}
          columns={columns || ""}
          disable_expanding_small={footer.disable_expanding_small
            ? "yes"
            : "no"}
          onfooterClick={(el: { detail: FooterEvents["footerClick"] }) =>
            dispatch("footerClick", el.detail)}
        ></hb-footer>
      </div>
    </div>
  {/if}
</div>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
